// extracted by mini-css-extract-plugin
module.exports = {"carousel":"ProductCarousel_carousel__rkbOe","viewport":"ProductCarousel_viewport__nioo_","scrollbar":"ProductCarousel_scrollbar__9BF_a","track":"ProductCarousel_track__JCkgv"};